<template>
    <div class="home">
        <div class="home-top">
            <div class="info box betweeen" @click="userShow()">
                <div class="info-l">
                    <div class="pic">
                        <img :src="userInfo.avatar" alt="" />
                    </div>
                    <div class="p">{{userInfo.nickName}}</div>
                </div>
                <div class="info-r">
                    <div class="p">个人中心</div>
                    <img src="@/assets/img/home/right.png" alt="" />
                </div>
            </div>
            <div class="find box">
                <div class="op">
                    <div class="searchbox">
                        <input type="search" placeholder="请输入起运港(例:QingDao)" v-model="loadingPart" @input="remoteMethod" />
                        <div class="search_show" v-show="startShow">
                            <div class="item" v-for="(value, key) in starList" :key="key" @click="selectStart(value)">
                                <div class="li">
                                    <p>{{value}}</p>
                                </div>
                            </div>
                            <div class="item" v-if="starList.length === 0">
                                <div class="li">
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="searchbox">
                        <input type="search" placeholder="请输入目的港(例:QingDao)" v-model="destinationPart" @input="remoteTwo" />
                        <div class="search_show" v-show="endShow">
                            <div class="item" v-for="(value, key) in endList" :key="key" :label="value" :value="value" @click="selectEnd(value)">
                                <div class="li">
                                    <p>{{value}}</p>
                                </div>
                            </div>
                            <div class="item" v-if="endList.length === 0">
                                <div class="li">
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button @click="search(loadingPart,destinationPart)" v-prevent-re-click>立即查询</button>
            </div>
        </div>
        <div class="subscribe box">
            <div class="tit">
                <img src="@/assets/img/subscribe.png" alt="">
                <div class="p">我的订阅</div>
            </div>

            <div class="pic center" v-if="collectList == ''">
                <img src="@/assets/img/nodata.png" alt="">
                <div class="p">暂无订阅记录</div>
            </div>
            <div class="team" v-else>
                <div class="item" v-for="item in collectList" :key="item.id" @click="more(item.loadingPartName,item.destinationPartName)">
                    <div class="route">
                        <div class="p">{{item.loadingPartName}}</div>
                        <img src="@/assets/img/route.png" alt="">
                        <div class="p">{{item.destinationPartName}}</div>
                    </div>
                    <div class="detail">
                        <div class="p">详情</div>
                        <img src="@/assets/img/right.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <Usercenter v-show="isShow" />
        <div id="loadingToast" v-show="loading">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">数据加载中</p>
            </div>
        </div>
    </div>
</template>
<script>
import Usercenter from '../user/index'
import { mapGetters } from "vuex";
export default {
    components: {
        Usercenter
    },
    data() {
        return {
            loadingPart: '',
            destinationPart: '',
            starForm: {
                name: '',
                type: 1
            },
            starList: [],
            endForm: {
                name: '',
                type: 2
            },
            endList: [],
            data: [],
            isShow: false,
            options: [],
            value: [],
            list: [],
            loading: false,
            collectList: [],
            startShow: false,
            endShow: false,
            startClick: false,
            endClick: false,
        };
    },
    computed: {
        ...mapGetters({ userInfo: "getUser" })

    },
    created() {
        this.mySubscriptions()
        this.getUserInfo()
        window.addEventListener("click", this.clickBlur, true); //监听函数
    },
    methods: {
        getUserInfo() {
            // if(!window.localStorage.getItem('token')){
            //     this.$router.push('/login')
            // }
            if (!this.userInfo.phone) {
                this.$router.push(
                    { path: '/bindphone' }
                )
            }
        },
        clickBlur() {
            this.startShow = false;
            this.endShow = false;
            if (!this.startClick) {
                this.loadingPart = ''
            }
            if (!this.endClick) {
                this.destinationPart = ''
            }
        },
        getPort(form) {
            this.$http.get("/wx/portList", {
                params: form
            }).then(res => {
                if (res.data.code == 0) {
                    return res.data.data
                }
                this.loading = false;
            });
        },
        changePort() {
            this.getPort();
        },
        userShow() { //子组件也调用
            this.isShow = !this.isShow;
        },
        remoteMethod() {
            this.startClick = false
            if (this.loadingPart !== '') {
                this.starForm.name = this.loadingPart;
                this.$http.get("/wx/portList", {
                    params: this.starForm
                }).then(res => {
                    if (res.data.code == 0) {
                        this.starList = res.data.data;
                        this.startShow = true;
                    }
                });
            } else {
                this.starList = {};
            }
        },
        remoteTwo() {
            this.endClick = false
            if (this.destinationPart !== '') {
                this.endForm.name = this.destinationPart;
                this.$http.get("/wx/portList", {
                    params: this.endForm
                }).then(res => {
                    if (res.data.code == 0) {
                        this.endList = res.data.data;
                        this.endShow = true;
                    }
                });
            } else {
                this.endList = {};
            }
        },
        more(loadingVal, destinationVal) {
            this.$router.push({ path: '/detail', query: { loadingPart: loadingVal, destinationPart: destinationVal } })
        },
        mySubscriptions() {
            this.$http.post("/wx/collectList").then(res => {
                if (res.data && res.data.code == 0) {
                    this.collectList = res.data.data
                }
            });
        },
        selectStart(value) {
            this.loadingPart = value
            this.startShow = false
            this.startClick = true
        },
        selectEnd(value) {
            this.destinationPart = value
            this.endShow = false
            this.endClick = true
        },
        search(loadingVal, destinationVal) {
            if (loadingVal == "" || destinationVal == "") {
                this.$weui.topTips("请选择港口");
            } else {
                this.$router.push({ path: '/detail', query: { loadingPart: this.loadingPart, destinationPart: this.destinationPart } })
            }
        }
    },
    mounted() {
    },
    destroyed() {
        window.removeEventListener("click", this.clickBlur, true);
    }
};
</script>

<style lang='less' scoped>
.home {
    width: 100%;
    min-height: 100vh;
    background: url("../../assets/img/home/bg.png") no-repeat top center;
    background-size: 100% 900px;
    padding-bottom: 20px;
    .home-top {
        width: 100%;
        .info {
            padding-top: 56px;
            .info-l {
                display: flex;
                align-items: center;
                .pic {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
                .p {
                    font-size: 30px;
                    color: #ffffff;
                    padding-left: 14px;
                }
            }
            .info-r {
                display: flex;
                align-items: center;
                .p {
                    font-size: 26px;
                    line-height: 26px;
                    color: #ffffff;
                    padding-right: 10px;
                }
                img {
                    width: auto;
                    height: 18px;
                }
            }
        }
        .find {
            box-shadow: 0 6px 20px 0 #eeeeee;
            border-radius: 6px;
            background: #ffffff;
            margin-top: 62px;
            position: relative;
            padding-top: 20px;
            padding-bottom: 40px;
            button {
                width: 500px;
                height: 90px;
                background: #2865ff;
                border-radius: 45px;
                margin: 40px auto 0 auto;
                font-size: 34px;
                color: #ffffff;
                display: block;
            }
            .op {
                width: 610px;
                margin: 0 auto;
                border-bottom: 2px solid #eeeeee;
                background: url("../../assets/img/lc.png") 20px center no-repeat;
                background-size: 16px auto;
                .searchbox {
                    position: relative;
                    height: 110px;
                    input {
                        width: 560px;
                        height: 110px;
                        margin: 0 auto;
                        padding-left: 60px;
                        font-size: 30px;
                        vertical-align: top;
                    }
                    .search_show {
                        background: #ffffff;
                        z-index: 200;
                        position: absolute !important;
                        top: 110px;
                        left: 40px;
                        width: 500px;
                        max-height: 50vh;
                        overflow-x: hidden;
                        overflow-y: auto;
                        .item {
                            width: 500px;
                            height: 90px;
                            line-height: 90px;
                            padding-left: 20px;
                            z-index: 200;
                            background: #f5f5f5f5;
                            .li {
                                p {
                                    font-size: 28px;
                                }
                            }
                        }
                    }
                }
            }
            .pic {
                width: 16px;
                height: auto;
                position: absolute;
                top: 87px;
                left: 40px;
                img {
                    width: 16px;
                }
            }
        }
    }
    .subscribe {
        width: 90%;
        background: #ffffff;
        box-shadow: 0 0 20px 0 #eeeeee;
        border-radius: 6px;
        border-radius: 6px;
        margin: 32px;
        .tit {
            width: 630px;
            height: 108px;
            margin: 0 auto;
            border-bottom: 1px solid #eeeeee;
            display: flex;
            align-items: center;
            img {
                width: 34px;
            }
            .p {
                font-size: 34px;
                color: #333333;
                padding-left: 11px;
            }
        }
        .team {
            width: 630px;
            margin: 0 auto;
            .item {
                width: 100%;
                padding: 35px 0;
                border-bottom: 1px solid #eeeeee;
                display: flex;
                justify-content: space-between;
                .route {
                    display: flex;
                    align-items: center;
                    .p {
                        font-size: 28px;
                        color: #333333;
                        width: 200px;
                        word-break: break-word;
                    }
                    img {
                        width: 24px;
                        margin: 0 24px;
                    }
                }
                .detail {
                    display: flex;
                    align-items: center;
                    .p {
                        font-size: 26px;
                        color: #999999;
                        padding-right: 15px;
                        white-space: nowrap;
                    }
                    img {
                        width: 22px;
                    }
                }
            }
            .item:last-child {
                border: 0;
            }
        }
        .pic {
            padding: 90px 0 160px;
            flex-direction: column;
            img {
                width: 324px;
            }
            .p {
                font-size: 28px;
                color: #333333;
            }
        }
    }
}
::-webkit-input-placeholder{
    font-size: 30px;
    color:#cccccc;
}
</style>
